module.exports = __webpack_public_path__ + "static/img/city-gold.dfdfbe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gold-about/city-gold.png
// module id = 1052
// module chunks = 173